var paragraph_default = {
  "fontElementMap": "Nlmkj",
  "elementSpacing": "oIANA",
  "text": "xdJir oIANA",
  "child": "OC8h1"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
